import { Static, Type } from '@sinclair/typebox'

export enum FeedbackSource {
    FLOWS = 'flows',
    MCP = 'mcp',
}

export const FEEDBACK_RATE_LIMIT = 3
export const FEEDBACK_RATE_WINDOW_SECONDS = 60 * 60
export const FEEDBACK_MIN_LENGTH = 10
export const FEEDBACK_MAX_LENGTH = 1500

export const SubmitFeedbackRequest = Type.Object({
    feedback: Type.String({ minLength: FEEDBACK_MIN_LENGTH, maxLength: FEEDBACK_MAX_LENGTH }),
    source: Type.Enum(FeedbackSource),
})

export type SubmitFeedbackRequest = Static<typeof SubmitFeedbackRequest>

export const SubmitFeedbackResponse = Type.Object({
    success: Type.Boolean(),
})

export type SubmitFeedbackResponse = Static<typeof SubmitFeedbackResponse>
